"use client"

import { cn } from "@/lib/utils"
import Link from "next/link"
import { useState } from "react"
import HEADER_MENUS_DESKTOP from "@/config/header-menu-dekstop"
import { MotionFadeInDiv } from "@/components/motion-ui/motion-fade-in-div"

const HeaderMenu = () => {
  return (
    <div
      className={cn(
        "hidden h-[45px] grow justify-center lg_flex lg_gap-[40px]"
      )}
    >
      {HEADER_MENUS_DESKTOP.map(
        ({ label, href, subMenu, hasDropdownMenu }, index) => {
          return (
            <HeaderMenuItem
              label={label}
              href={href}
              key={index}
              subMenu={subMenu}
              hasDropdownMenu={hasDropdownMenu}
            />
          )
        }
      )}
    </div>
  )
}

const HeaderMenuItem = ({
  label,
  href,
  subMenu,
  hasDropdownMenu,
}: {
  label: string
  href: string
  subMenu: any
  hasDropdownMenu: boolean
}) => {
  const [showDropdown, setShowDropdown] = useState(true)

  return (
    <>
      <div
        className={cn(
          "flex items-center ",
          hasDropdownMenu && "group/container",
          showDropdown && hasDropdownMenu ? "[&_+_div]_hover_block" : ""
        )}
        onMouseEnter={() => {
          setShowDropdown(true)
        }}
      >
        <Link
          onClick={() => {
            setShowDropdown(false)
          }}
          className="relative flex h-full items-center"
          href={href}
        >
          <div className="relative flex justify-center">
            <div className="relative inline-block font-sans font-[600] capitalize leading-[45px] text-title hover_font-[600] hover_text-primary">
              {label}
              {hasDropdownMenu && showDropdown && (
                <div className="absolute bottom-0 left-0 h-[3px] w-full lg_group-hover/container_bg-primary" />
              )}
            </div>
          </div>
        </Link>
        {hasDropdownMenu && showDropdown ? (
          <div className="absolute left-0 top-full z-[1] hidden w-full bg-[#F7F7F5] shadow-header-menu duration-4xl animate-in fade-in-0 lg_group-hover/container_block">
            {subMenu}
            <div className="absolute bottom-0 left-0  h-[5px] w-full bg-[#F7F7F5]"></div>
          </div>
        ) : null}
      </div>
      {hasDropdownMenu && (
        <div
          className={cn(
            "hidden h-0 ",
            "lg_h-[100vh]",
            "absolute left-0 top-full  w-full bg-[rgba(0,0,0,.3)]"
          )}
        />
      )}
    </>
  )
}

export default HeaderMenu
